/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Para agregarles estilos a tus componentes en React solo necesitas importar tus hojas de estilos donde las necesites.`}</p>
    <p><inlineCode parentName="p">{`create-react-app`}</inlineCode>{` utiliza por defecto archivos `}<em parentName="p">{`CSS`}</em>{`, pero puedes añadir fácilmente tu preprocesador favorito ya sea `}<em parentName="p">{`Sass`}</em>{`, `}<em parentName="p">{`Less`}</em>{` o `}<em parentName="p">{`Stylus`}</em>{`.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'./styles/pokedex.css'`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// import './styles/pokedex.sass';`}</span>{`
`}</code></pre></div>
    <p>{`Si quieres que tus estilos sean más poderosos puedes agregar styled-components.`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-jsx"
      }}><code parentName="pre" {...{
          "className": "language-jsx"
        }}><span parentName="code" {...{
            "className": "token keyword module"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token imports"
          }}>{`styled`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword module"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'styled-components'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token maybe-class-name"
          }}>{`PokedexStyled`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` styled`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token property-access"
          }}>{`div`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token css language-css"
            }}>{`
  `}<span parentName="span" {...{
                "className": "token property"
              }}>{`height`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token number"
              }}>{`31`}</span><span parentName="span" {...{
                "className": "token unit"
              }}>{`rem`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`;`}</span>{`
  `}<span parentName="span" {...{
                "className": "token property"
              }}>{`width`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`:`}</span>{` `}<span parentName="span" {...{
                "className": "token number"
              }}>{`23`}</span><span parentName="span" {...{
                "className": "token unit"
              }}>{`rem`}</span><span parentName="span" {...{
                "className": "token punctuation"
              }}>{`;`}</span>{`
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span>{`
`}</code></pre></div>
    <p>{`Es importante recordar que en `}<em parentName="p">{`React`}</em>{` utilizamos `}<inlineCode parentName="p">{`className`}</inlineCode>{`, en vez de `}<inlineCode parentName="p">{`class`}</inlineCode>{` para asignarle una clase de CSS a nuestros elementos debido a que `}<inlineCode parentName="p">{`class`}</inlineCode>{` es una palabra reservada en JavaScript`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;